let width = 768

export const ModalZindex = 1000

export const ModalStyle = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: ModalZindex
  },
  content: {
    position: 'default',
    border: '1px solid #dddddd',
    borderRadius: '2px',
    marginLeft: `calc(50% - ${width / 2}px)`,
    marginTop: '100px',
    padding: '0',
    width: `${width}px`,
    boxShadow: '0px 16px 24px 0px rgba(0, 0, 0, 0.24)',
    MozBoxShadow: '0px 16px 24px 0px rgba(0, 0, 0, 0.24)',
    WebkitBoxShadow: '0px 16px 24px 0px rgba(0, 0, 0, 0.24)'
  }
}



// WEBPACK FOOTER //
// ./src/constants/modalConfig.js